module.exports = {
        srcSet: __webpack_public_path__ + "shell-banner-half-772-64f0df3ee8bc5ca7.digested.webp"+" 772w",
        images: [{path: __webpack_public_path__ + "shell-banner-half-772-64f0df3ee8bc5ca7.digested.webp",width: 772,height: 320}],
        src: __webpack_public_path__ + "shell-banner-half-772-64f0df3ee8bc5ca7.digested.webp",
        toString: function(){return __webpack_public_path__ + "shell-banner-half-772-64f0df3ee8bc5ca7.digested.webp"},
        
        width: 772,
        height: 320
      }